import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Radio,
  message,
  Spin,
} from "antd";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import Endpoints from "../../../api/endpoints";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const CardInformation = ({ initialValues, isLoading, shopId, onSuccess }) => {
  const [form] = Form.useForm();
  const axiosPrivate = useAxiosPrivate();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  useEffect(() => {
    if (initialValues) {
      const formValues = {
        cardTitle: initialValues.cardTitle || "",
        stampCountForPrize: initialValues.stampCountForPrize || "",
        prize: initialValues.prize || "",
        welcomePrize: initialValues.welcomePrize || "",
        status: initialValues.status ?? 1,
        conditions: initialValues.conditions || "",
      };
      form.setFieldsValue(formValues);
    }
  }, [initialValues, form]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    setIsSubmitLoading(true);
    const requestBody = {
      shopId: shopId,
      ...values,
    };
    const response = await EndpointFunctions.putData({
      endpointURL: Endpoints.updateShopCardDetails,
      axiosPrivate: axiosPrivate,
      data: requestBody,
    });
    if (response.success) {
      message.success("Kart bilgileri güncellendi");
      if (onSuccess) {
        onSuccess();
      }
    } else {
      message.error("Kart bilgileri güncellenemedi");
    }
    setIsSubmitLoading(false);
  };

  return (
    <Card
      type="inner"
      style={{ marginTop: 16 }}
      title="Kart Bilgileri"
      extra={
        <Button type="primary" onClick={handleSubmit} loading={isLoading}>
          Kaydet
        </Button>
      }>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item name="cardTitle" label="Kart Başlığı">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="stampCountForPrize"
              label="Ödül için Gereken Damga">
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="prize" label="Ödül">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="welcomePrize" label="Hoşgeldin Ödülü">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="status" label="Kart Durumu">
              <Radio.Group>
                <Radio value={1}>Aktif</Radio>
                <Radio value={0}>Pasif</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="conditions" label="Koşullar">
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default CardInformation;
